import "./Eventlogs.scss";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import PagerAmount from "../../Components/Pager/PagerAmount";
import Popup from "../../Components/Popup/Popup";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import { ROUTE_EVENTLOG, ROUTE_MAP } from "../../routes";
import { STORE_EVENTLOGS } from "../../Store/EventlogsStore";
import axios from "axios";
import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);
import { formatDate } from "../../utility";
import { timeout } from "q";

const Search = inject((stores) => ({
  store: stores.store.get(STORE_EVENTLOGS),
}))(
  observer((props) => {
    const { store } = props;
    const cancelClassname =
      "search-cancel-button" + (store.search.length > 0 ? "" : " hidden");
    return (
      <div className="eventlogs-search">
        <div className="eventlogs-search__label">Keresés</div>
        {/*<div className="table-search__input-container">      
        <input className="form-input form-input--inline" type="text" name="focus" value={store.search} onChange={e => store.setSearch(e.target.value)} />       
    </div>*/}
        <div className="search-wrapper">
          <input
            className="search-input"
            value={store.search}
            onChange={(e) => store.setSearch(e.target.value)}
          />
          <div className={cancelClassname} onClick={(e) => store.setSearch("")}>
            <i className="fas fa-times"></i>
          </div>
        </div>
      </div>
    );
  })
);

@inject((stores) => ({
  store: stores.store.get(STORE_EVENTLOGS),
  configStore: stores.store.get(STORE_CONFIG),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class Eventlogs extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { store } = this.props;

    const today = new Date();
    store.setFrom(today);
    store.setTo(today);

    this.refresh();
  }

  refresh() {
    const { store, socket } = this.props;

    const data = {
      From: store.from ? store.fromFormatted + " 00:00:00" : null,
      To: store.to ? store.toFormatted + " 23:59:59" : null,
    };

    socket.emitWithToken("GetEventlogs", data, function (err, data) {
      if (err) {
        console.error(err);
        return;
      }
      store.setItems(data);
    });
  }

  inventoryChanged = (data) => {
    //this.refresh()
  };

  render() {
    const { store, configStore, route, router } = this.props;
    const { shownItems } = store;
    let { name: routeName, params: routeParams } = route;

    let rows = [];

    shownItems.forEach((log) => {
      rows.push(
        <Eventlog
          timestamp={log.Timestamp}
          operation={log.Operation}
          username={log.UserName}
          details={log.Details}
        />
      );
    });
    if (store.logCount <= shownItems.length) {
      rows.push(
        <div
          className="showmorebutton"
          onClick={() => store.increaseLogCount()}
        >
          Mutass többet...
        </div>
      );
    }

    return (
      <Frame>
        <div className="eventlogs basic-content">
          <div className="eventlogs__top">
            <div className="table-datepicker-block">
              Időszak&nbsp;
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.from}
                onChange={(date) => {
                  store.setFrom(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
              <div className="separator"></div>
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.to}
                onChange={(date) => {
                  store.setTo(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
            </div>
            <Search />
          </div>
          <div className="eventlogs_content">{rows}</div>
        </div>
      </Frame>
    );
  }
}

class Eventlog extends React.Component {
  render() {
    const { timestamp, operation, username, details } = this.props;

    return (
      <div className="eventlog_container">
        <div className="eventlog_singledata" key="timestamp">
          {timestamp}
        </div>
        <div className="eventlog_singledata" key="operation">
          {operation}
        </div>
        <div className="eventlog_singledata" key="username">
          {username}
        </div>

        <table className="eventlog_details">
          {details.map((detail) => {
            return (
              <tr className="eventlog_detail">
                <td className="eventlog_detail_name">{detail.Name}</td>
                <td className="eventlog_detail_value">{detail.Value}</td>
              </tr>
            );
          })}
        </table>
      </div>
    );
  }
}

export {
  SORT_ASC,
  SORT_DESC,
  SORT_ID,
  SORT_MACHINE,
  SORT_CLEANINGRATE,
  SORT_SUPPLIER,
  SORT_LOTNO,
  SORT_AMOUNT,
  SORT_CREATED,
  SORT_TERMINATED,
  SORT_STATUS,
  SORT_LOCATION,
  SORT_ITEM,
  SORT_QPURITY,
  SORT_QALIENSEED,
  SORT_QHARDSEED,
  SORT_QGERM,
  SORT_QWATER,
};

export default (props) => (
  <RouteNode nodeName={ROUTE_EVENTLOG}>
    {(routeProps) => <Eventlogs {...routeProps} {...props} />}
  </RouteNode>
);
